module.exports = __webpack_public_path__ + "img/Unauthorized.02176cbd.png";